<style lang="scss" scoped></style>

<template>
  <div>
    <el-dialog :title="$t('xuanzegongyicanshu')" :visible.sync="visible" width="576px">
      <el-table :data="tableData" @selection-change="handleSelectionChange" height="250">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column show-overflow-tooltip v-for="(item, index) in tableColumns" :key="index" :property="item.prop" :label="$t(item.label)" :width="item.width"></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button size="mini" @click="visible = false">{{ $t('quxiao') }}</el-button>
        <el-button size="mini" type="primary" @click="sure">{{ $t('queding') }}</el-button>
      </span>
    </el-dialog>

    <sendPointDialog :show.sync="showSendPointDialog" :equipmentId="equipmentId" :codeList="selectedRows"></sendPointDialog>
  </div>
</template>

<script type="text/javascript">
import sendPointDialog from './sendPointDialog.vue';

export default {
  name: 'web_ai_application_process_optimization_dialog_choosePointDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // AI的回答
    answer: {
      type: String,
      default: ''
    },
    // 设备ID
    equipmentId: {
      type: Number,
      required: true
    }
  },
  components: {
    sendPointDialog
  },
  data() {
    return {
      visible: false,
      tableData: [],
      selectedRows: [],
      showSendPointDialog: false,
      tableColumns: [
        {
          prop: 'desc',
          label: 'miaoshu',
          width: '150'
        },
        {
          prop: 'code',
          label: 'bianma',
          width: '80'
        },
        {
          prop: 'beforeValue',
          label: 'youhuaqian',
          width: '80'
        },
        {
          prop: 'afterValue',
          label: 'youhuahou',
          width: '80'
        },
        {
          prop: 'unit',
          label: 'danwei',
          width: '80'
        }
      ]
    };
  },
  watch: {
    show(newVal, oldVal) {
      this.visible = newVal;
      if (newVal) {
        this.getTableData();
      }
    },
    visible(newVal, oldVal) {
      if (!newVal) this.$emit('update:show', false);
    }
  },
  methods: {
    // 确定选择的点位
    sure() {
      if (this.selectedRows.length === 0) {
        this.$message.warning(this.$t('qingzhishaoxuanzeyigecanshu'));
        return;
      }
      this.showSendPointDialog = !this.showSendPointDialog;
    },
    // 解析生产表格数据
    getTableData() {
      const str = this.answer;
      if (!str) {
        return;
      }
      // 找到“建议参数”和“参数调整理由”的位置
      const startIndex = str.indexOf('建议参数:') + '建议参数:'.length;
      const endIndex = str.indexOf('参数调整理由:');
      // 提取内容
      const paramStr = str.slice(startIndex, endIndex).trim();
      const lines = paramStr.split('\n');
      const tableData = [];
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        try {
          const split = line.split('(');
          const desc = split[0].trim();
          const code = split[1].split(')')[0].trim();
          const right = line.split(':')[1];
          const split1 = right.split('->');
          const split2 = split1[1].trim().split(' ');
          const split3 = split1[0].trim().split(' ');
          const afterValue = split2[0].trim();
          const beforeValue = split3[0].trim();
          const unit = split2[1].trim();
          const obj = {
            desc: desc,
            code: code,
            beforeValue: beforeValue,
            afterValue: afterValue,
            unit: unit
          };
          tableData.push(obj);
        } catch (err) {
          console.log(err);
          continue;
        }
      }
      this.tableData = tableData;
    },
    handleSelectionChange(rows) {
      console.log(rows);
      this.selectedRows = rows;
    }
  }
};
</script>
